import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/juegos-de-azar/';

/**
 * GET JuegosDeAzar
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getJuegosDeAzar = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET JuegosDeAzar
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getJuegoDeAzar = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST JuegosDeAzar
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postJuegoDeAzar = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH JuegoDeAzar
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchJuegoDeAzar = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE JuegoDeAzar
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteJuegoDeAzar = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios JuegosDeAzar
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosJuegosDeAzar = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Juegos de azar para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getJuegosDeAzarCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/juego-de-azar-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
